import { ReactElement, useState } from 'react'
import { Box, Tab, Tabs, Typography } from '@mui/material'

// Only a Description tab exists today — no Resources/Notes tabs, since
// there's no data behind them yet. Structured as a single-tab Tabs bar
// (rather than skipping Tabs entirely) so those can be added later without
// restructuring this component.
export let VideoDescriptionTabs = ({
  description,
}: {
  description: string
}): ReactElement => {
  let [activeTab, setActiveTab] = useState('description')

  return (
    <Box sx={{ mt: 4 }}>
      <Tabs
        value={activeTab}
        onChange={(_, value) => setActiveTab(value)}
        sx={{ borderBottom: '1px solid', borderColor: 'divider' }}
      >
        <Tab label="Description" value="description" />
      </Tabs>
      <Typography variant="body1" sx={{ mt: 3, whiteSpace: 'pre-line' }}>
        {description}
      </Typography>
    </Box>
  )
}
